import { Component } from 'react';
import { withRouter } from "react-router"

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {

    if(window.location.pathname==="/"||window.location.pathname==="/AR/"){
    }else{
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0)
  
      }
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)